// extracted by mini-css-extract-plugin
module.exports = {"resourceList":"resourceList___uTUGh","card":"card___1JixT"};